<template functional>
  <div class="video-collection-placeholder p-2 h-100">
    <div
      class="video-collection-placeholder__image h-100"
    />
    <small
      class="video-collection-placeholder__indicator"
    >{{ props.index + 1 }}</small>
    <div
      class="video-collection-placeholder__text my-3 w-100"
    />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.video-collection-placeholder {
  display: flex;
}
.video-collection-placeholder__image {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  background-color: rgba(white, 0.1);
}
.video-collection-placeholder__text {
  margin-right: 16px;
  background-color: rgba(white, 0.1);
  height: 1em;

  animation: breathing 2s infinite alternate;
  transform-origin: left;
}
.video-collection-placeholder__indicator {
  margin-top: 6px;
  margin-left: 6px;
  margin-right: 6px;
  opacity: 0.35;
}

@keyframes breathing {
  0% { transform: scale(0.95) }
  100% { transform: scale(1.05) }
}
</style>
